import React, { useState, useEffect } from 'react';
import { 
    Dialog, 
    DialogContent, 
    DialogActions, 
    Button, 
    TextField, 
    Typography,
    Box
} from '@mui/material';
import Heading from '../../Components/Heading/heading.tsx';
import Dropdown from '../../Components/DropDown/drop-down.tsx'; 
import { addTickets } from './action.ts'; 
import { toast } from 'react-toastify';

interface AddTicketDialogProps {
    open: boolean;
    handleClose: () => void;
    initialCompanyId: string; 
    companyOptions: { id: string, label: string }[]; 
    onSuccess: () => void; 
}

const issueOptions = [
    { id: 'Notification Issue', label: 'Notification Issue' },
    { id: 'Route/Map Issue', label: 'Route/Map Issue' },
    { id: 'Van Location not updating in map', label: 'Van Location not updating in map' },
    { id: 'Wrong van displayed in map', label: 'Wrong van displayed in map' },
    { id: 'ETA shown is inaccurate', label: 'ETA shown is inaccurate' },
    { id: 'Pickup location shown is wrong', label: 'Pickup location shown is wrong' },
    { id: 'Others', label: 'Others' }
];

const AddTicketDialog: React.FC<AddTicketDialogProps> = ({ open, handleClose, initialCompanyId, companyOptions, onSuccess }) => {
    const [selectedCompanyId, setSelectedCompanyId] = useState('');
    const [issue, setIssue] = useState('');
    const [remarks, setRemarks] = useState('');

    useEffect(() => {
        if (open) {
            setSelectedCompanyId(initialCompanyId || '');
            setIssue('');
            setRemarks('');
        }
    }, [open, initialCompanyId]);

    const handleSubmit = () => {
        if (!selectedCompanyId) {
            toast.warning("Please select a company.");
            return;
        }

        addTickets(
            issue,               
            remarks,            
            selectedCompanyId, 
            (response) => {
                toast.success(response?.message || "Ticket created successfully");
                onSuccess(); 
                handleClose();
            },
            (errorMsg) => {
                toast.error(typeof errorMsg === 'string' ? errorMsg : "Failed to create ticket");
            }
        );
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm">
            <Box sx={{ marginLeft: { xs: '0px', sm: '-180px' } }}>    
                <Heading title="Add Ticket" closeIcon="true" onClose={handleClose} />
            </Box>
            
            <DialogContent>
                <Box mb={3}>
                    <Dropdown 
                        options={companyOptions}
                        selectedValue={selectedCompanyId} 
                        handleChange={(e: any) => {
                            setSelectedCompanyId(String(e.target.value));
                        }} 
                        label="Company *"
                        placeholder="Select a company"
                        width="350px" 
                        height="40px"
                        searchable={true}
                    />
                </Box>

                <Box mb={3}>
                    <Dropdown 
                        options={issueOptions}
                        selectedValue={issue} 
                        handleChange={(e: any) => {
                            setIssue(String(e.target.value));
                        }} 
                        label="What's this about?"
                        placeholder="Select an issue"
                        width="350px" 
                        height="40px"
                        searchable={true}
                    />
                </Box>

                <Box>
                    <TextField
                        multiline
                        rows={4}
                        variant="outlined"
                        placeholder="Describe your concern..."
                        label="Remarks"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        sx={{ width: '350px' }}
                    />
                </Box>
            </DialogContent>

            <DialogActions style={{ justifyContent: 'center' }}>
                <Button onClick={handleClose} className="custom-cancel-button">
                    Cancel
                </Button>
                <Button 
                    onClick={handleSubmit} 
                    variant="contained" 
                    className="custom-button"
                    disabled={!issue || !selectedCompanyId}
                >
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddTicketDialog;